import {AllDevices, AnimalSpecies, AnimalSpeciesCustomers, Batteries, BatteryTypes, BootloaderVersions, Cameras, CheckIridiumDeviceStatus, Collars, CommandsAdmin, CommandsCustomer, ConfigFiles, ConfigurationDevices, DataLoggers, DeviceClasses, DeviceCommandTypes, DeviceFeatures, DeviceTypesAdmin, DeviceTypesCustomer, DropOffs, ExternalSensors, FirmwareClasses, FirmwareVersions, HousingTypes, InitialDeviceRelation, LongRangeDevices, PCBTypes, ParameterListVersion, ParametersAdmin, ParametersCategories, ParametersCustomer, RefurbSplit, ScheduleTemplatesAdmin, ScheduleTemplatesCustomer, ScheduleTypes, Schedules, Subsystems, TT4Sensors, Traps, Items} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public AllDevices: AllDevices,
    public AnimalSpecies: AnimalSpecies,
    public AnimalSpeciesCustomers: AnimalSpeciesCustomers,
    public Batteries: Batteries,
    public BatteryTypes: BatteryTypes,
    public BootloaderVersions: BootloaderVersions,
    public Cameras: Cameras,
    public CheckIridiumDeviceStatus: CheckIridiumDeviceStatus,
    public Collars: Collars,
    public CommandsAdmin: CommandsAdmin,
    public CommandsCustomer: CommandsCustomer,
    public ConfigFiles: ConfigFiles,
    public ConfigurationDevices: ConfigurationDevices,
    public DataLoggers: DataLoggers,
    public DeviceClasses: DeviceClasses,
    public DeviceCommandTypes: DeviceCommandTypes,
    public DeviceFeatures: DeviceFeatures,
    public DeviceTypesAdmin: DeviceTypesAdmin,
    public DeviceTypesCustomer: DeviceTypesCustomer,
    public DropOffs: DropOffs,
    public ExternalSensors: ExternalSensors,
    public FirmwareClasses: FirmwareClasses,
    public FirmwareVersions: FirmwareVersions,
    public HousingTypes: HousingTypes,
    public InitialDeviceRelation: InitialDeviceRelation,
    public LongRangeDevices: LongRangeDevices,
    public PCBTypes: PCBTypes,
    public ParameterListVersion: ParameterListVersion,
    public ParametersAdmin: ParametersAdmin,
    public ParametersCategories: ParametersCategories,
    public ParametersCustomer: ParametersCustomer,
    public RefurbSplit: RefurbSplit,
    public ScheduleTemplatesAdmin: ScheduleTemplatesAdmin,
    public ScheduleTemplatesCustomer: ScheduleTemplatesCustomer,
    public ScheduleTypes: ScheduleTypes,
    public Schedules: Schedules,
    public Subsystems: Subsystems,
    public TT4Sensors: TT4Sensors,
    public Traps: Traps,
    public Items: Items,
  ) {}
}